import React, { useState } from "react";
import { Grid, Button, Stack, ThemeProvider } from "@mui/material";
import StudentsListPage from "../../StudentsList";
import TransferStudentList from "./transferStudent/TransferStudentList";
import mainTheme from "../../../../../newComponent/themeprovider/mainTheme/MainTheme";

export default function EnrolledStudentList() {
  const [selected, setSelected] = useState("active");
  const userRole=localStorage.getItem('userRole')

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <ThemeProvider theme={mainTheme}>
            
            <Button
            size="small"
              variant={selected === "active" ? "contained" : "outlined"}
              onClick={() => setSelected("active")}
              style={{
                backgroundColor:
                  selected === "active" ? "#4CAF50" : "transparent",
                color: selected === "active" ? "#fff" : "#4CAF50",
                borderColor: "#4CAF50",
                "&:hover": {
                  backgroundColor:
                    selected === "active" ? "#43a047" : "#e8f5e9",
                },
              }}
            >
              Enrolled  Students List
            </Button>

{userRole==="center_admin" && ( 
            <Button
            size="small"
              variant={selected === "inactive" ? "contained" : "outlined"}
              onClick={() => setSelected("inactive")}
              style={{
                backgroundColor:
                  selected === "inactive" ? "#4CAF50" : "transparent",
                color: selected === "inactive" ? "#fff" : "#4CAF50",
                borderColor: "#4CAF50",
                "&:hover": {
                  backgroundColor:
                    selected === "inactive" ? "#43a047" : "#e8f5e9",
                },
              }}
            >
              Transfer Students 
            </Button>
)}
            </ThemeProvider>

          </Stack>
        </Grid>

        <Grid item xs={12}>
            {selected === "active" ? (
              <StudentsListPage />
            ) : (
              <TransferStudentList/>
            )}
        </Grid>
      </Grid>
    </>
  );
}